import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('@/views/ApplicationView.vue')
  },
  {
    path: '/tariff',
    name: 'tariff',
    component: () => import('@/views/TariffView.vue')
  },
  {
    path: '/confirm-payment/:telegramId/:uid',
    name: 'confirm-payment',
    component: () => import('@/views/ConfirmPayment.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/AccountView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/AccountSettings.vue')
  },
  {
    path: '/ecosystem',
    name: 'ecosystem',
    component: () => import('@/views/EcosystemView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/NewsView.vue')
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import('@/views/PartnersView.vue')
  },
  {
    path: '/partner/:partnerId',
    name: 'partner-detail',
    component: () => import('@/views/PartnerDetail.vue')
  },
  {
    path: '/materials',
    name: 'materials',
    component: () => import('@/views/MaterialsView.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/ContactView.vue')
  },
  {
    path: '/favourite-residents',
    name: 'favourite-residents',
    component: () => import('@/views/FavouriteResidents.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('@/views/EventsView.vue')
  },
  {
    path: '/event/:eventId',
    name: 'event-detail',
    component: () => import('@/views/EventDetail.vue')
  },
  {
    path: '/residents',
    name: 'residents',
    component: () => import('@/views/ResidentsView.vue')
  },
  {
    path: '/resident/:uin',
    name: 'resident-detail',
    component: () => import('@/views/ResidentDetail.vue')
  },
  {
    path: '/event/:eventId/order',
    name: 'event-order',
    component: () => import('@/views/OrderEventView.vue')
  },
  {
    path: '/order/payment/:orderUuid',
    name: 'order-payment',
    component: () => import('@/views/OrderPayment.vue')
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('@/views/MarketView.vue')
  },
  {
    path: '/product/:param',
    name: 'product',
    component: () => import('@/views/ProductDetail.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@/views/CartView.vue')
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/OnboardingView.vue')
  },
  {
    path: '/matching',
    name: 'matching',
    component: () => import('@/views/MatchingView.vue')
  },
  {
    path: '/matching/:companyId',
    name: 'matching-company',
    component: () => import('@/views/MatchingCompany.vue')
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/NotificationsView.vue')
  },
  {
    path: '/account/tariff',
    name: 'account-tariff',
    component: () => import('@/views/TariffDetail.vue')
  },
  {
    path: '/news/:newsId',
    name: 'news-detail',
    component: () => import('@/views/NewsDetail.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

export default router
